// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-window {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: #e5ddd5;
  width: 80%;
  margin: 0 auto;
}

.m-header {
  display: flex;
  align-items: center;
  padding: 1% 2%;
  background: #00468c;
  color: #fff;
  border-bottom: 1px solid #00468c;
}
.header-avatar {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  margin-right: 16px;
}
.chat-header-title {
  font-size: 20px;
  font-weight: 500;
}

.messages {
  flex: 1 1;
  overflow-y: auto;
  padding: 24px;
  background: #e2e1e0;
  width: 100%;
}

.msg-row {
  display: flex;
  align-items: flex-end;
  margin-bottom: 16px;
}
.msg-row.me {
  padding: 0;
  justify-content: flex-end;
  margin-right: 0;
}
.msg-row.them {
  justify-content: flex-start;
}

.msg-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  margin-right: 12px;
}

.msg-spacer {
  width: 48px;
}

.msg-bubble {
  max-width: 60%;
  min-width: 3%;
  padding: 12px 16px;
  border-radius: 12px;
  position: relative;
  font-size: 15px;
  line-height: 1.4;
  word-wrap: break-word;
  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
  padding-bottom: 24px;
}

.me-bubble {
  background: #001f3f;
  border-bottom-right-radius: 4px;
  color: #fff;
}
.them-bubble {
  background: #dbeafe;
  border-bottom-left-radius: 4px;
}

.msg-time {
  width: 50px;
  font-size: 11px;
  color: gray;
  position: absolute;
  bottom: 4px;
  right: 8px;
  margin-top: 4px;
}

.input-area {
  position: relative;
  display: flex;
  align-items: center;
  padding: 12px 24px;
  border-top: 1px solid #ccc;
  background: #f0f0f0;
}

.emoji-picker-container {
  position: relative;
}

.emoji-dropdown {
  position: absolute;
  bottom: 48px;
  left: 0;
  z-index: 1000;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
}

.m-input {
  flex: 1 1;
  padding: 12px 16px;
  margin: 0 8px;
  border: 1px solid #ccc;
  border-radius: 24px;
  outline: none;
  font-size: 15px;
  resize: none;
  line-height: 0.5;
}

.icon-btn {
  background: none;
  border: none;
  margin: 0 8px;
  font-size: 22px;
  color: #00468c;
  cursor: pointer;
}

.send-btn {
  background: none;
  border: none;
  color: #00468c;
  font-size: 24px;
  cursor: pointer;
}

.msg-sender {
  font-size: 12px;
  font-weight: bold;
  margin-bottom: 4px;
  color: #555;
  background-color: rgb(179, 253, 172);
  text-align: left;
}

.msg-download-btn {
  border: none;
  font-size: 14px;
  cursor: pointer;
}

.msg-download-btn:hover {
  color: #0078d4;
}

.msg-row {
  position: relative;
  display: flex;
  align-items: flex-end;
  margin-bottom: 16px;
}

.date-separator {
  text-align: center;
  margin: 16px 0;
  font-size: 0.9em;
  color: #666;
  position: relative;
}

.date-separator::before,
.date-separator::after {
  content: "";
  display: inline-block;
  width: 30%;
  height: 1px;
  background: #ccc;
  vertical-align: middle;
  margin: 0 0.5em;
}

.msg-row {
  position: relative;
}

.msg-icons {
  position: absolute;
  top: 4px;
  right: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.msg-icons .msg-delete-btn,
.msg-icons .msg-address-icon {
  opacity: 0;
  transition: opacity 0.15s ease-in-out;
}

.msg-row:hover .msg-icons .msg-delete-btn,
.msg-row:hover .msg-icons .msg-address-icon {
  opacity: 1;
}

.msg-address-icon {
  margin-bottom: 4px;
  font-size: 1.1rem;
  background: none;
  border: none;
  cursor: pointer;
  color: #666;
}
.msg-address-icon:hover {
  color: #333;
}

.msg-delete-btn {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 1rem;
  color: #c00;
}
`, "",{"version":3,"sources":["webpack://./src/components/Chat/ChatWindow.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,WAAW;EACX,gCAAgC;AAClC;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,UAAU;EACV,yBAAyB;EACzB,eAAe;AACjB;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,wCAAwC;EACxC,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,WAAW;EACX,eAAe;EACf,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;EACX,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;;EAEE,WAAW;EACX,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;;EAEE,UAAU;EACV,qCAAqC;AACvC;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,WAAW;AACb;AACA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,WAAW;AACb","sourcesContent":[".chat-window {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  background: #e5ddd5;\n  width: 80%;\n  margin: 0 auto;\n}\n\n.m-header {\n  display: flex;\n  align-items: center;\n  padding: 1% 2%;\n  background: #00468c;\n  color: #fff;\n  border-bottom: 1px solid #00468c;\n}\n.header-avatar {\n  width: 48px;\n  height: 48px;\n  border-radius: 50%;\n  margin-right: 16px;\n}\n.chat-header-title {\n  font-size: 20px;\n  font-weight: 500;\n}\n\n.messages {\n  flex: 1;\n  overflow-y: auto;\n  padding: 24px;\n  background: #e2e1e0;\n  width: 100%;\n}\n\n.msg-row {\n  display: flex;\n  align-items: flex-end;\n  margin-bottom: 16px;\n}\n.msg-row.me {\n  padding: 0;\n  justify-content: flex-end;\n  margin-right: 0;\n}\n.msg-row.them {\n  justify-content: flex-start;\n}\n\n.msg-avatar {\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  margin-right: 12px;\n}\n\n.msg-spacer {\n  width: 48px;\n}\n\n.msg-bubble {\n  max-width: 60%;\n  min-width: 3%;\n  padding: 12px 16px;\n  border-radius: 12px;\n  position: relative;\n  font-size: 15px;\n  line-height: 1.4;\n  word-wrap: break-word;\n  box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);\n  padding-bottom: 24px;\n}\n\n.me-bubble {\n  background: #001f3f;\n  border-bottom-right-radius: 4px;\n  color: #fff;\n}\n.them-bubble {\n  background: #dbeafe;\n  border-bottom-left-radius: 4px;\n}\n\n.msg-time {\n  width: 50px;\n  font-size: 11px;\n  color: gray;\n  position: absolute;\n  bottom: 4px;\n  right: 8px;\n  margin-top: 4px;\n}\n\n.input-area {\n  position: relative;\n  display: flex;\n  align-items: center;\n  padding: 12px 24px;\n  border-top: 1px solid #ccc;\n  background: #f0f0f0;\n}\n\n.emoji-picker-container {\n  position: relative;\n}\n\n.emoji-dropdown {\n  position: absolute;\n  bottom: 48px;\n  left: 0;\n  z-index: 1000;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);\n}\n\n.m-input {\n  flex: 1;\n  padding: 12px 16px;\n  margin: 0 8px;\n  border: 1px solid #ccc;\n  border-radius: 24px;\n  outline: none;\n  font-size: 15px;\n  resize: none;\n  line-height: 0.5;\n}\n\n.icon-btn {\n  background: none;\n  border: none;\n  margin: 0 8px;\n  font-size: 22px;\n  color: #00468c;\n  cursor: pointer;\n}\n\n.send-btn {\n  background: none;\n  border: none;\n  color: #00468c;\n  font-size: 24px;\n  cursor: pointer;\n}\n\n.msg-sender {\n  font-size: 12px;\n  font-weight: bold;\n  margin-bottom: 4px;\n  color: #555;\n  background-color: rgb(179, 253, 172);\n  text-align: left;\n}\n\n.msg-download-btn {\n  border: none;\n  font-size: 14px;\n  cursor: pointer;\n}\n\n.msg-download-btn:hover {\n  color: #0078d4;\n}\n\n.msg-row {\n  position: relative;\n  display: flex;\n  align-items: flex-end;\n  margin-bottom: 16px;\n}\n\n.date-separator {\n  text-align: center;\n  margin: 16px 0;\n  font-size: 0.9em;\n  color: #666;\n  position: relative;\n}\n\n.date-separator::before,\n.date-separator::after {\n  content: \"\";\n  display: inline-block;\n  width: 30%;\n  height: 1px;\n  background: #ccc;\n  vertical-align: middle;\n  margin: 0 0.5em;\n}\n\n.msg-row {\n  position: relative;\n}\n\n.msg-icons {\n  position: absolute;\n  top: 4px;\n  right: 8px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.msg-icons .msg-delete-btn,\n.msg-icons .msg-address-icon {\n  opacity: 0;\n  transition: opacity 0.15s ease-in-out;\n}\n\n.msg-row:hover .msg-icons .msg-delete-btn,\n.msg-row:hover .msg-icons .msg-address-icon {\n  opacity: 1;\n}\n\n.msg-address-icon {\n  margin-bottom: 4px;\n  font-size: 1.1rem;\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #666;\n}\n.msg-address-icon:hover {\n  color: #333;\n}\n\n.msg-delete-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  font-size: 1rem;\n  color: #c00;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
